import { BiddingQuery } from '~/config/generated/graphql';

export const handleBiddingView = ({ auctionTipsModel }: BiddingQuery) => {
  return {
    structuredText: auctionTipsModel?.structuredText?.structuredText
  };
};
